<template>
  <div class="ReSelectClearable">
    <div class="col-md-12 d-flex" style="align-items: center;">
      <el-select
        class="w-100 select-primary"
        size="large"
        :placeholder="placeholder"
        v-model="localValue"
        @change="onChange"
      >
        <el-option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :label="option.label"
        ></el-option>
      </el-select>

      <base-button 
        type="danger" 
        class="no-border my-0" 
        simple 
        icon 
        @click="resetToClearValue"
      >
        <i class="d-inline-block tim-icons icon-simple-remove"></i>
      </base-button>
    </div>
  </div>
</template>

<script>
import { Select, Option, Tooltip, Button } from 'element-ui';
export default {
	name: 'ReSelectClearable',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,
		[Button.name]: Button
	},

	props: {
		value: [String, Number],
		options: {
			type: Array,
			required: true
		},
		placeholder: String,
		clearValue: [String, Number, Function]
	},

	data() {
		return {
			localValue: this.value
		};
	},

	watch: {
		value(val) {
			this.localValue = val;
		}
	},

	methods: {
		onChange(newValue) {
			this.$emit('change', newValue);
		},

		resetToClearValue() {
			if (this.clearValue !== undefined) {
			this.localValue = this.clearValue;
			this.$emit('change', this.clearValue);
			}
		}
	}
};
</script>

<style scoped>
	.ReSelectClearable {
		display: flex;
		width: 100%;
	}
</style>
